/* Training module — sample data + rules ported from the prototype. */

export const TRAINING_REQUESTS = [
  {
    id: "TR-2026-084",
    course: "Successful Project Management",
    provider: "Malaysian Institute of Management",
    dates: "11 Nov - 14 Nov 2026",
    cost: "RM 2,450.00",
    status: "Pending Approval",
    year: "2026",
  },
  {
    id: "TR-2026-062",
    course: "Advanced Laravel API Integrations",
    provider: "Laracasts / Online",
    dates: "05 Sep - 07 Sep 2026",
    cost: "RM 1,200.00",
    status: "Approved",
    year: "2026",
  },
  {
    id: "TR-2026-015",
    course: "Certified Quality Assurance Professional",
    provider: "QA Academy Malaysia",
    dates: "10 Feb - 14 Feb 2026",
    cost: "RM 3,800.00",
    status: "Completed",
    year: "2026",
  },
];

export const getTrainingStatus = (id) => {
  const row = TRAINING_REQUESTS.find((request) => request.id === id);
  return row ? row.status : "Approved";
};

export const STATUS_BADGE_CLASS = {
  "Pending Approval": "status-pending",
  Approved: "status-approved",
  Completed: "status-completed",
  Rejected: "status-rejected",
  Cancelled: "status-cancelled",
};

/* Approval flow: Requestor -> organisational approvers -> Admin. */
export const buildTimeline = (status) => {
  const submitted = { state: "done", title: "Request Submitted", meta: "12 Aug 2026, 9:22 AM · Eldren Aniell" };
  const flows = {
    "Pending Approval": [
      submitted,
      { state: "current", title: "Head of Unit Approval", meta: "Awaiting review by the assigned Head of Unit" },
      { state: "pending", title: "Head of Department Approval", meta: "Starts after Head of Unit approval" },
      { state: "pending", title: "Admin Approval", meta: "Starts after organisational approval" },
    ],
    Approved: [
      submitted,
      { state: "done", title: "Head of Unit Approved", meta: "13 Aug 2026, 10:15 AM · Chloe Lim Yee Ling" },
      { state: "done", title: "Head of Department Approved", meta: "13 Aug 2026, 4:20 PM · Joachim Soon" },
      { state: "done", title: "Admin Approved", meta: "14 Aug 2026, 2:40 PM · Portal Admin" },
    ],
    Rejected: [
      submitted,
      { state: "rejected", title: "Rejected by Head of Unit", meta: "13 Aug 2026, 10:15 AM · Chloe Lim Yee Ling — see reason above" },
      { state: "pending", title: "Head of Department Approval", meta: "Not started — request was rejected" },
      { state: "pending", title: "Admin Approval", meta: "Not started — request was rejected" },
    ],
    Completed: [
      submitted,
      { state: "done", title: "Head of Unit Approved", meta: "13 Aug 2026, 10:15 AM · Chloe Lim Yee Ling" },
      { state: "done", title: "Head of Department Approved", meta: "13 Aug 2026, 4:20 PM · Joachim Soon" },
      { state: "done", title: "Admin Approved", meta: "14 Aug 2026, 2:40 PM · Portal Admin" },
      { state: "done", title: "Training Completed", meta: "14 Feb 2026 · Evaluation submitted" },
    ],
  };
  return flows[status] || flows.Approved;
};

export const TRAINING_REJECTION_REASON =
  'Head of Unit: "Course dates clash with the project milestone week. Please pick a later intake and resubmit."';

export const ACTIVITY_LOG = [
  { time: "14 Aug 2026, 2:40 PM", by: "Portal Admin", role: "Admin", action: "Approved", badge: "approved", detail: "Training request approved. Budget deduction of RM 1,200.00 reserved against the training budget." },
  { time: "13 Aug 2026, 4:20 PM", by: "Joachim Soon", role: "Head of Department", action: "Approved", badge: "approved", detail: "Department approval completed." },
  { time: "13 Aug 2026, 10:15 AM", by: "Chloe Lim Yee Ling", role: "Head of Unit", action: "Approved", badge: "approved", detail: 'Approved. Note: "Relevant to current project portfolio — supported."' },
  { time: "12 Aug 2026, 9:22 AM", by: "Eldren Aniell", role: "Requestor", action: "Amended", badge: "amend", detail: 'Resubmitted after amendment. Changes: Course Dates 04–07 Nov → 11–14 Nov 2026 · Course Fee RM 1,450.00 → RM 1,200.00. Reason: "Earlier intake is full; later intake also has a lower fee."' },
  { time: "11 Aug 2026, 3:05 PM", by: "Chloe Lim Yee Ling", role: "Head of Unit", action: "Rejected", badge: "reject", detail: 'Reason: "Course dates clash with the project milestone week. Please pick a later intake and resubmit."' },
  { time: "11 Aug 2026, 8:50 AM", by: "Eldren Aniell", role: "Requestor", action: "Submitted", badge: "info", detail: "Training request submitted for approval. Total estimated cost: RM 1,450.00." },
  { time: "10 Aug 2026, 4:18 PM", by: "Eldren Aniell", role: "Requestor", action: "Created", badge: "muted", detail: "Draft created from New Training Request." },
];
